/**
 * Privacy Policy - English v2
 * 
 * Effective Date: February 1, 2026
 */
export const PRIVACY_V2_EN = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "en",
    title: "Privacy Policy",
    content: `
Spot Go Privacy Policy

Last Updated: February 1, 2026 (KST)

This Privacy Policy explains how Spot Go Developer ("Developer", "we", "us") collects, uses, and discloses your information when you use our service Spot Go ("Service").

1. Information We Collect

We only collect and store data necessary for operating and improving the Service.

1.1 Pi Network Account Information

When you log in to the Service, we receive your unique Pi Network user ID and nickname. We do not receive or store your Pi Network password.

1.2 Usage Data

We store your nickname and user ID on our servers for account management, leaderboard rankings, and usage records.

1.3 Shipping Information (Optional)

When product delivery is required, we collect shipping information (name, address, contact) that you directly enter. This information is used only for delivery purposes.

1.4 Post Information

We store the content, images, and location information of posts (Spots) you register.

2. How We Use Information

• Providing and maintaining the Service
• Managing accounts and storing usage records
• Product delivery (when applicable)
• Protecting Service security and integrity

2-1. Public Display of Nickname

To provide ranking and community features, your Pi Network nickname may be publicly displayed to other users within the Service (e.g., leaderboards, posts).

3. Information Sharing

We do not sell or rent personal information. We may share information only in the following cases:

• Service Providers: Firebase (data storage), Cloudflare (image storage)
• Legal Reasons: We may disclose information when required by law or to protect rights

4. Data Deletion

You can request data deletion by sending an email with the subject "Data Deletion Request" to lukep81@painori.com. Upon processing, all data will be permanently deleted.

5. Data Security

We use reasonable technical measures to protect your data, but no method of transmission over the Internet is 100% secure.

6. International Data Transfer

Your data may be transferred to and stored on servers outside your country (Google Firebase, Cloudflare). By using the Service, you consent to such transfers.

7. Children's Privacy

Our Service is not intended for children under the age of 14. We do not knowingly collect data from children. If we become aware that we have collected such data, we will delete it immediately.

8. Contact Us

If you have questions about this Privacy Policy, please contact: lukep81@painori.com
`.trim()
};
